import { translate } from './translations'

const Routes = {
  home: '/',
  page: '/:page',
  chapters: `/${translate('slug.chapters')}`,
  chapter: `/${translate('slug.chapters')}/:chapter`,
  lesson: `/${translate('slug.chapters')}/:chapter/:lesson`,
  endtest: `/${translate('slug.endtest')}`,
  endtestQuestion: `/${translate('slug.endtest')}/:question`,
  endtestSummary: `/${translate('slug.endtest')}/${translate('slug.endtestSummary')}`,
}

Routes.path = name => {
  return Routes[name]
}

Routes.to = (name, params) => {
  let url = Routes.path(name)
  if (params) Object.entries(params).map(prop => url = url.replace(`:${prop[0]}`, prop[1]))

  return url
}

export default {
  to: Routes.to,
  path: Routes.path
}
